import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ModerationConfig extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    get context() {
        return this.object.config.context;
    }

    get icon() {
        return this.object.config.icon ?? 'users';
    }

    static list(item) {
        return new this(item);
    }

    static listUrl({ organizationId }) {
        return `/ticket/organizations/${organizationId}/moderation_flows/config`;
    }
}
